import {
    DEFAULT_LANG,
    SUPPORTED_LANG_CODES,
    SupportedLangCode,
    buildLocalizedPath,
} from '../../config/languages';

const BASE_URL = 'https://balancepath.space';

export const getBlogArticlePath = (slug: string, lang: SupportedLangCode): string =>
    buildLocalizedPath(`/${slug}`, lang);

export const getBlogArticleCanonicalUrl = (slug: string, lang: SupportedLangCode): string =>
    `${BASE_URL}${getBlogArticlePath(slug, lang)}`;

export const getBlogArticleLangUrls = (
    slug: string,
): Partial<Record<SupportedLangCode, string>> => {
    const urls: Partial<Record<SupportedLangCode, string>> = {};
    for (const lang of SUPPORTED_LANG_CODES) {
        urls[lang] = getBlogArticleCanonicalUrl(slug, lang);
    }
    return urls;
};

export const getBlogArticleDefaultUrl = (slug: string): string =>
    getBlogArticleCanonicalUrl(slug, DEFAULT_LANG);
